import MDRouter from "@/service/router";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orders: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ifShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    ordersList() {
      return this.orders || [];
    }
  },
  methods: {
    closePopup() {
      this.ifShow = false;
    },
    goToOrderDetail(orderId) {
      if (orderId) {
        MDRouter.Link(`/order/detail?order_id=${orderId}`, 'wap');
        this.closePopup();
      }
    }
  }
};